import React from "react";
import { Control, Controller } from "react-hook-form";

import { Input, ErrorUI } from "@/components/Atoms";

import { isValidName } from "@/utils";

import {
  InputGroupV2,
  InputWrapperV2,
  InputGroupV3,
  InputWrapperV3,
} from "../style";

interface NameInputProps {
  name: string;
  control: Control<any>;
  namePlaceholder: string;
  showLabels?: boolean;
  inputFontSize?: string;
  inputLineHeight?: string;
  isNotAbsolute?: boolean;
  handleBlur?: (e: any) => void;
  showIcon?: boolean;
  variant?: "v1" | "v2" | "v3";
}

const NameInput: React.FC<NameInputProps> = ({
  name,
  control,
  showLabels,
  namePlaceholder,
  inputFontSize,
  inputLineHeight,
  isNotAbsolute,
  handleBlur = () => {},
  showIcon,
  variant = "v3",
}) => {
  const inputController = (
    <Controller
      name={name}
      control={control}
      shouldUnregister
      render={({
        field: { value, onBlur, onChange, ref },
        fieldState: { error },
      }) => (
        <>
          <Input
            ref={ref}
            type="text"
            placeholder={namePlaceholder}
            name={name}
            value={value}
            onChange={(e) => {
              if (e.target.value === "" || isValidName(e.target.value)) {
                onChange(e);
              }
            }}
            onBlur={(e) => {
              onBlur(e).then((e) => {
                if (handleBlur) {
                  handleBlur(e);
                }
              });
            }}
            icon={showIcon && "icon-user-face-2"}
            iconDimension="16px"
            variant={variant}
            inputFontSize={inputFontSize}
            inputLineHeight={inputLineHeight}
          />
          {error && (
            <ErrorUI
              hasBottomBorder
              error={error?.message}
              isNotAbsolute={isNotAbsolute}
            />
          )}
        </>
      )}
    />
  );

  if (variant === "v1") {
    return <></>;
  } else if (variant === "v2") {
    return (
      <InputWrapperV2>
        <InputGroupV2 hasBottomBorder showLabels={showLabels}>
          {inputController}
        </InputGroupV2>
      </InputWrapperV2>
    );
  } else {
    return (
      <InputWrapperV3>
        <InputGroupV3 hasBottomBorder showLabels={showLabels}>
          {inputController}
        </InputGroupV3>
      </InputWrapperV3>
    );
  }
};

export default NameInput;
